import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { NavLink } from 'reactstrap';
import { v4 } from 'uuid';

export class ListTabs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showBurger: false,
            id: v4()
        };

        this.resizeTabs = this.resizeTabs.bind(this);
        this.onDocumentClick = this.onDocumentClick.bind(this);

        window.addEventListener('resize', this.resizeTabs);
        document.addEventListener('click', this.onDocumentClick);
    }

    componentDidMount() {
        this.resizeTabs();
    }

    componentDidUpdate() {
        this.resizeTabs();
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.resizeTabs);
        document.removeEventListener('click', this.onDocumentClick);
    }

    onDocumentClick(e) {
        if (e.target) {
            const root = document.getElementById(this.state.id);
            const burger = root?.querySelector('.burger-item');
            if (this.state.showBurger && burger && e.target !== burger && !burger.contains(e.target)) {
                this.setState({ showBurger: false });
            }
        }
    }

    resizeTabs() {
        const root = document.getElementById(this.state.id);
        if (root) {
            const tabList = root.querySelector('.tabs');
            if (tabList) {
                const contanerWidth = tabList.getBoundingClientRect().width;
                const elements = tabList.children;
                if (elements.length > 0) {
                    let currentWidth = 0;
                    let showAll = true;
                    let lastVisible = null;

                    const burgerTab = elements[elements.length - 1];

                    for (let i = 0; i < elements.length - 1; i++) {
                        const index = elements[i].getAttribute('item-index');
                        const burgerEment = burgerTab.querySelector(`li[item-index="${index}"]`);

                        const elementPos = elements[i].getBoundingClientRect();
                        currentWidth += elementPos.width;
                        if (elementPos.width === 0) {
                            currentWidth += parseInt(elements[i].getAttribute('tab-width'));
                        }
                        if (currentWidth > contanerWidth) {
                            if (elementPos.width > 0) elements[i].setAttribute('tab-width', elementPos.width);
                            elements[i].style.display = 'none';
                            showAll = false;
                            if (burgerEment) burgerEment.style.display = 'block';
                        }
                        else {
                            elements[i].style.display = 'block';
                            lastVisible = elements[i];
                            if (burgerEment) burgerEment.style.display = 'none';
                        }
                    }
                    if (showAll) {
                        burgerTab.style.display = 'none';
                    }
                    else {
                        burgerTab.style.display = 'block';
                        const burgerPos = burgerTab.getBoundingClientRect();
                        if (lastVisible && burgerPos.left + burgerPos.width > contanerWidth) {
                            const lasVisiblePos = lastVisible.getBoundingClientRect();
                            if (lasVisiblePos.width > 0) lastVisible.setAttribute('tab-width', lasVisiblePos.width);
                            lastVisible.style.display = 'none';

                            const index = lastVisible.getAttribute('item-index');
                            const burgerEment = burgerTab.querySelector(`li[item-index="${index}"]`);
                            if (burgerEment) burgerEment.style.display = 'block';
                        }
                    }

                    const activeBurgerTab = burgerTab.querySelector('.active');
                    if (activeBurgerTab && activeBurgerTab.style.display === 'block') {
                        burgerTab.classList.add('active');
                    }
                    else {
                        burgerTab.classList.remove('active');
                    }
                }
            }
        }
    }

    render() {
        const { items, selectedItem } = this.props;
        const { showBurger, id } = this.state;

        let index = 0;
        let burgerIndex = 0;

        return (<div className="tabsMobile" key={id} id={id} >
            <ul className="tabs">
                {items.map(item =>
                    <li className={item === selectedItem ? "active" : ""} item-index={index} key={item.name ? item.name + '_' + index++ : index++}>
                        {item === selectedItem ?
                            <div className="nav-link">{item.link?.text}</div>
                            :
                            <NavLink tag={Link} to={item.link?.url}>{item.link?.text}</NavLink>
                        }
                    </li>
                )}
                <li className={"burger-item" + (showBurger ? " show" : "")} onClick={() => this.setState({ showBurger: !showBurger })}>
                    <div className="burger-item-content">
                        <svg width="24" height="21" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 8C13.1 8 14 7.1 14 6C14 4.9 13.1 4 12 4C10.9 4 10 4.9 10 6C10 7.1 10.9 8 12 8ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10ZM12 16C10.9 16 10 16.9 10 18C10 19.1 10.9 20 12 20C13.1 20 14 19.1 14 18C14 16.9 13.1 16 12 16Z" fill="black"></path></svg>
                        <ul className="burger-items" style={{ display: showBurger ? "block" : "none" }} >
                            {items?.map(item =>
                                <li className={item === selectedItem ? "active" : ""} item-index={burgerIndex++} key={item.name ? item.name + '_burger_' + index++ : index++}>
                                    {item === selectedItem ?
                                        <div className="nav-link">{item.link?.text}</div>
                                        :
                                        <NavLink tag={Link} to={item.link?.url}>{item.link?.text}</NavLink>
                                    }
                                </li>
                            )}
                        </ul>
                    </div>
                </li>
            </ul>
        </div>);
    }
}